import './Home.css';
import Video from "../images/FirstPageImage.png";
// import TextWithButton from "../components/TextWithButton.js"
import { Link } from 'react-router-dom';


function Home() {

  // let service2Props = {
  //   header: "Υπηρεσία 2",
  //   title: "Υπηρεσία εύρεσης δείκτη ευημερίας ανά περιοχή",
  //   text: "Λίγα λόγια για την υπηρεσία",
  //   link: "/WellBeingIndexByRegion"
  // }


  return (
    <div>

      <section id= "FirstPage">      
        {/* ---------------------------------------- First Page----------------------------------------------- */}
      <div className = "section-container">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div id = "FirstPageText">
                <h1 style = {{marginBottom: "5%"}}>Δείκτης ικανοποίησης μετακινούμενων</h1>

                <p>Η ευημερία είναι ένας πολύπλευρος και πολύπλοκος όρος
                   που δεν προσδιορίζεται εύκολα, επειδή εμπεριέχει πολλούς και διαφορετικού τομείς.</p>

                <p>«Ένας περιεκτικός ορισμός της ευημερίας είναι ο εξής: “η ευημερία είναι το σημείο ισορροπίας μεταξύ της ομάδας διαθέσιμων πόρων ενός ατόμου και των προκλήσεων που αντιμετωπίζει”».</p>  
              </div>

            </div>
            <div className="col-lg-5" id = "VideoPos">
              <img src={Video} width="300" height="450" alt=""/>
            </div>
          </div>
        </div>
      </div>
      </section>


      <div className='container' style = {{marginTop: "10%", marginBottom: "10%"}}>
          <p>Υπηρεσία 1</p>
          <h3>Ανάπτυξη καινοτόμων μεθοδολογιών για την αποτίμηση δεικτών ευημερίας στον τομέα των μεταφορών</h3>
          <p>Η υπηρεσία 5.3.6.1 βασιζόμενη σε ανώνυμη διαδικτυακή έρευνα ερωτηματολογίου που εκπονήθηκε από το Εργαστήριο Σχεδιασμού Μεταφορών,
            Συγκοινωνιακής Τεχνικής & Οδοποιίας του Τομέα Συγκοινωνιακών & Υδραυλικών Έργων του Τμήματος Αγρονόμων & Τοπογράφων Μηχανικών της
             Πολυτεχνικής Σχολής του Αριστοτέλειου Πανεπιστημίου Θεσσαλονίκης (Α.Π.Θ) για το έτος 2021:</p>
          <p>Προσδιορίζει το επίπεδο ικανοποίησης των χρηστών των μεσών Δημόσιας Συγκοινωνίας καθώς και του Ι.Χ. επιβατικού αυτοκινήτου.</p>
          <p style = {{marginTop: 0}}>Καταγράφει γενικότερα θέματα κινητικότητας.</p>

          <p>Η έρευνα απευθύνθηκε σε κατοίκους των Δημών: Θεσσαλονίκης, Καλαμαριάς, Νεάπολης - Συκεών, Παύλου Μελά, Κορδελιού - Ευόσμου, Αμπελοκήπων - Μενεμένης, Πυλαίας - Χορτιάτη, Δέλτα, Θερμαϊκού, Θέρμης και Ωραιόκαστρου.</p>
          <p>Η έρευνα πραγματοποιήθηκε στο διάστημα 20/5/2021 - 2/6/2021 και συνολικά συγκεντρώθηκαν 1460 ερωτηματολόγια.</p>
          <p>Το ερωτηματολόγιο που αναπτύχθηκε και χρησιμοποιήθηκε συντίθεται από δύο (2) ομάδες ερωτήσεων.</p>
          <Link to= {"/WellBeingIndex"}>
              <button className = "ServiceButton"> Μετάβαση στην Υπηρεσία</button>
          </Link>
      </div>


      {/* <hr></hr>
      <TextWithButton props = {service2Props}> </TextWithButton> */}

    </div>
  );
}

export default Home;
